import { useTranslation } from 'react-i18next';
import { EMPTY_ILLUSTRATIONS, EmptyContainer, Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import DocumentImportPatternsTableRowActions from './document-import-patterns-table-row-actions.component';

import { IDocumentPatternTableProps } from './document-import-patterns-table.interfaces';

const DocumentImportPatternsTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  onTableChange,
  loading,
}: IDocumentPatternTableProps) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('common:emptyContainer.emptyTitle')}
          />
        ),
      }}
      t={t}
    >
      <Table.Column
        title={t('settings:documentImporter.labels.name')}
        sorter={onTableChange}
        render={({ title }) => <Typography>{title}</Typography>}
      />

      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <DocumentImportPatternsTableRowActions record={record} handleModals={handleModals} t={t} />
        )}
      />
    </Table>
  );
};

export default DocumentImportPatternsTable;
